<template>
  <div class="auto-reg">
    <HeroBlock v-bind="hero"></HeroBlock>
    <div class="block">
      <CardBlock :cards="cards"></CardBlock>
      <DescriptionBlock v-bind="description"></DescriptionBlock>
      <LikeBlock v-bind="like"></LikeBlock>
    </div>
    <Toggle :cards="cards" :description="description" :like="like"></Toggle>
    <DoubleDemo :videos="videos" :demo="demoModal"></DoubleDemo>
    <Calculator :calculator="calculator"></Calculator>
  </div>
</template>

<script>
import HeroBlock from "@/components/hero-block";
import CardBlock from "@/components/cards-block";
import DescriptionBlock from "@/components/description-block";
import LikeBlock from "@/components/like-block";
import Toggle from "@/components/toggle";
import DoubleDemo from "@/components/double-videos";
import Calculator from "@/components/calculator";

export default {
  components: {
    HeroBlock,
    CardBlock,
    DescriptionBlock,
    LikeBlock,
    Toggle,
    DoubleDemo,
    Calculator
  },
  data() {
    return {
      hero: {
        title: `Программа лояльности ТРЦ`,
        paragraphs: [
          `Мультиплатформенная система накопления бонусных баллов и приобретения призов <br>
          за накопленные бонусы. Программа работает в автоматическом режиме со всеми <br>
          магазинами ТРЦ, не требует участия сотрудников для регистрации покупок <br>
          и не нуждается в выпуске пластиковых карт клиента.`,
          `Механика распознавания чеков программой содержит все преимущества <br>
          самостоятельной регистрации. Программа лояльности расширяет возможности <br>
          временныхстимулирующих мероприятий до постоянно действующей акции <br>
          с обновляемым фондом гарантированных призов.`
        ],
        src: require(`@/assets/images/hero3.png`)
      },
      cards: [
        {
          title: `Любимая акция покупателей`,
          paragraph: `Механика накопления баллов за покупки хорошо знакома клиентам ТРЦ. Редкий покупатель никогда не собирал наклейки <br>
          на сковородки, не копил бонусы на заправках или не пользовался кэшбэком. Теперь популярная система получения подарков <br>
          за покупки доступна и для торгово-развлекательных центров, независимо от количества арендаторов и разновидностей <br>
          кассовых аппаратов.`,
          src: require(`@/assets/images/card-loyal1.svg`)
        },
        {
          title: `Интуитивно понятный интерфейс`,
          paragraph: `Веб версия и чат-боты программы лояльности просты и понятны пользователям на любых устройствах. <br>
          В первом разделе участник программы лояльности фотографирует чеки и сразу видит начисление бонусных <br>
          баллов. В разделе призов - выбирает и получает понравившиеся призы как в обычном интернет-магазине.`,
          src: require(`@/assets/images/card-loyal2.svg`)
        },
        {
          title: `Гибкая настройка условий участия`,
          paragraph: `Сложные механики становятся простыми. Система позволяет учитывать разные факторы при регистрации чеков и поощрять <br>
          определенное поведение клиентов. К примеру, начислить дополнительные бонусы за регулярные посещения ТРЦ, <br>
          или предоставить доступ к уникальным призам за совершение крупных покупок. В программе регулируется "стоимость" <br>
          баллов для каждого арендатора, дни недели и даже период времени для совершения покупок.`,
          src: require(`@/assets/images/card-loyal3.svg`)
        },
        {
          title: `Эффект состязания`,
          paragraph: `Онлайн доступ к витрине призов и их количеству подстёгивает покупателей совершать покупки раньше <br>
          и не откладывать посещение ТРЦ. Система может сама регулировать количество доступных в день <br>
          призов, показывать или скрывать реальное количество подарков для создания ажиотажа вокруг акции.`,
          src: require(`@/assets/images/card-loyal4.svg`)
        }
      ],
      description: {
        title: `Лёгкое управление`,
        paragraphs: [
          `Руководитель акции управляет призовым фондом через удобный интерфейс добавления 
          и редактирования подарков. Работа в системе не требует специальных навыков, но если 
          трудности все же возникли, всегда доступна служба поддержки клиентов.`,
          `Управляющий корректирует ход акции, опираясь на точную статистику, которая обновляется
          в реальном времени и содержит подробные количественные и качественные отчеты.`
        ],
        src: require(`@/assets/images/description3.svg`)
      },
      like: {
        title: `Полноценное исследование аудитории`,
        paragraph: `Собираемая программой лояльности статистика существенно более репрезентативна, чем статистика временных стимулирующих акций. Во-первых, <br>
        программой лояльности пользуется гораздо больше покупателей, и количество их с течением времени только растет, повышая точность исследования. <br>
        Во-вторых, система позволяет оценить типичное повседневное покупательское поведение, без отклонений на импульсные решения.`,
        src: require(`@/assets/images/like3.svg`)
      },
      videos: [
        {
          id: `1`,
          title: `Как работает программа лояльности с мобильного телефона`,
          src: `https://www.youtube.com/embed/kBjSN4N0_d8`,
          preview: `https://i.ytimg.com/vi/kBjSN4N0_d8/maxresdefault.jpg`,
        },
        {
          id: `2`,
          title: `Как выглядит окно статистики и изменения персональных данных`,
          src: `https://www.youtube.com/embed/4GyFyGShTuU`,
          preview: `https://i.ytimg.com/vi/4GyFyGShTuU/maxresdefault.jpg`,
        }
      ],
      demoModal: {
        promise: `В демо-версии программы лояльности доступны две роли: покупатель и администратор акции. Как покупатель вы пройдете <br>
        регистрацию нового пользователя в веб-форме и чат-боте, зергистрируете покупку, выберете подарок. Как администратор, настроете <br>
        витрину подарков, отредактируете персональные данные и изучите форму подробной статистики демонстрационной акции.`,
        paragraph: `Для доступа к демо-версии программы лояльности Вам необходимо перейти <br>
        на CRM-платформу EventGO! Напишите нам свой имеил и мы вышлем на него <br>
        необходимые ссылки.`,
        mobileParagraph: `Испытайте все возможности программы в демонстрационном режиме и рассчитайте стоимость автоиматизации вашей акции! Откройете эту страницу на компьютере и вам станут доступными демо-режим и калькулятор стоимости.`
      },
      calculator: {
        choseTitle: `Длительность программы`,
        smParagraph: `Например, можно регистрировать <br>
        участников программы и сразу выдавать им <br>
        "моментальные" призы`
      }
    };
  }
};
</script>
